declare function gtag(...args: unknown[]): void;

export function trackRegistration() {
  if (typeof gtag === 'undefined') return;
  gtag('event', 'conversion', { send_to: 'AW-18122830717/8mDeCMyM3rccEP3m0cFD' });
}

export function trackEmailConfirmed() {
  if (typeof gtag === 'undefined') return;
  gtag('event', 'conversion', { send_to: 'AW-18122830717/WWJGCM-M3rccEP3m0cFD' });
}
